export default "__VITE_ASSET__BUW4GiQA__"